/**
 * Scoped context menu suppression: prevents the default menu when the user
 * right-clicks (or opens the context menu on) an <img> inside a marked subtree.
 */
function init() {
  document
    .querySelectorAll('[data-suppress-img-context="true"]')
    .forEach((root) => {
      root.addEventListener("contextmenu", (e) => {
        const t = e.target;
        if (!t || !t.closest) {
          return;
        }
        const img = t.closest("img");
        if (img && root.contains(img)) {
          e.preventDefault();
        }
      });
      // add draggable=false to all images inside the root
      root.querySelectorAll("img").forEach((img) => {
        img.setAttribute("draggable", "false");
      });
    });
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", init);
} else {
  init();
}
